import React from 'react';

const AboutSection = ({ aboutData }) => {
    return (
        <section className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    <div className="order-2 lg:order-1">
                        <h2 className="text-4xl lg:text-5xl font-light text-gray-900 mb-6">
                            {aboutData?.title || "About Me"}
                        </h2>
                        <div className="text-gray-600 leading-relaxed">
                            {aboutData?.content ? (
                                aboutData.content.split('\n').map((paragraph, index) => (
                                    <p key={index} className="mb-4 text-base lg:text-lg">
                                        {paragraph}
                                    </p>
                                ))
                            ) : (
                                <p className="text-base lg:text-lg">
                                    Welcome to my creative world where art, photography, and wellness converge.
                                    I'm passionate about capturing life's beautiful moments, creating meaningful art,
                                    and helping others find peace through yoga practice.
                                </p>
                            )}
                        </div>
                    </div>

                    <div className="order-1 lg:order-2">
                        {aboutData?.image ? (
                            <img
                                src={aboutData.image}
                                alt="About Savana"
                                className="w-full rounded-lg shadow-lg"
                            />
                        ) : (
                            <div className="w-full h-96 bg-gray-300 rounded-lg shadow-lg flex items-center justify-center">
                                <span className="text-gray-500">About Image</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutSection;